export default "__VITE_ASSET__BHvsMRNZ__"